import React from 'react';
import '../styles/EmailPreview.css';

const EmailPreview = ({ tituloCorpo, corpo, onClose }) => {
  return (
    <div className="emailpreview-backdrop">
      <div className="emailpreview-container">
        <button className="emailpreview-close" onClick={onClose}>✕</button>
        <div className="email-container">
          <div className="header">
            <img src="/agilerobots01.png" alt="AgileRobots Logo" />
          </div>
          <div className="content">
            <h1>{tituloCorpo}</h1>
            <p dangerouslySetInnerHTML={{ __html: corpo }} />
          </div>
          <div className="footer">
            <p>&copy; 2024 AgileSolution. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPreview;
